const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimerQuickmenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.39 12.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#fff;stroke-linecap:round;stroke-miterlimit:10;}.cls-1{stroke-width:0.49px;}.cls-2{stroke-width:0.68px;}")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "timer_quickmenu") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\u0428\u0430\u0440_2",
    "data-name": "\u0428\u0430\u0440 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\u0421\u043B\u043E\u0439_1",
    "data-name": "\u0421\u043B\u043E\u0439 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.33,7.22A1.51,1.51,0,0,0,.68,8.34a1.58,1.58,0,0,0,.65,1.33,1.42,1.42,0,0,1,0,2.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.69,7.22A1.51,1.51,0,0,0,2,8.34a1.58,1.58,0,0,0,.65,1.33,1.42,1.42,0,0,1,0,2.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4,7.22a1.51,1.51,0,0,0-.65,1.12A1.61,1.61,0,0,0,4,9.67,1.4,1.4,0,0,1,4,12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M.34,5.6A5.81,5.81,0,0,1,2.9,1.15a5.43,5.43,0,0,1,6.24.38,5.46,5.46,0,0,1,1.44,6.39A5.65,5.65,0,0,1,6,11.21"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "5.7 2.39 5.7 5.78 7.91 5.78"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerQuickmenu);
export default __webpack_public_path__ + "static/media/timer_quickmenu.7c21d71055601cb789dbb6b6b14e5702.svg";
export { ForwardRef as ReactComponent };